import atlas from "azure-maps-control";

import type {ScaleControlOptions} from "azure-maps-control";

export class AzureScaleBar extends atlas.control.ScaleControl {

    private unit: "imperial" | "metric" | "nautical"

    constructor(options?: ScaleControlOptions) {
        super(options);
        this.unit = options?.unit || "imperial";
    }

    public toggleUnits() {
        if (this.unit === 'imperial') {
            super.setUnit("metric");
            this.unit = 'metric';

        } else if (this.unit === 'metric') {
            super.setUnit("imperial")
            this.unit = 'imperial';
        }
    }

    public onAdd(map: atlas.Map, options?: atlas.ControlOptions): HTMLElement {
        const el =  super.onAdd(map, options);
        el.classList.add("es-azure-scale-bar")
        el.addEventListener("click", () => this.toggleUnits());
        return el;
    }
}
